import { AGGClient } from "src/clients";

const createQuery = (accountId: string) => {
    return `#graphql
    query InboundSalesQuery {
        growthUnifiedProfile_getUnifiedProfile(accountId: "${accountId}"){
            userProfile{
                domainType
                smbUserVisitedPricingPages
            }
            sites{
                cloudId
                displayName
                products{
                    productKey
                    productName
                    productEdition
                }
            }
        }
    }
`;
};

interface GetIsSMBSalesLeadProps {
    accountId: string;
    aggClient?: AGGClient;
}

type InboundSalesQueryResponse = {
    errors: Array<{
        message: string;
    }>;
    data: {
        growthUnifiedProfile_getUnifiedProfile: {
            sites: Array<{
                cloudId: string;
                displayName: string;
                products: Array<{
                    productEdition: string;
                    productKey: string;
                    productName: string;
                }>;
            }>;
            userProfile: {
                domainType: string;
                smbUserVisitedPricingPages: boolean;
            };
        };
    };
};

export const getIsSMBSalesLead = async ({
    accountId,
    aggClient = new AGGClient()
}: GetIsSMBSalesLeadProps): Promise<boolean> => {
    const customHeaders: { [key: string]: string } = {
        "x-use-case": "sales-inbound"
    };

    // X-Slauth-User-Context-Account-Id is only for local testing.
    // In a deployed environment, the service proxy translates the
    // user context token into this header
    if (process.env["NODE_ENV"] === "development") {
        customHeaders["X-Slauth-User-Context-Account-Id"] = accountId;
    }

    const { data, errors } = await aggClient.query<InboundSalesQueryResponse>(
        createQuery(accountId),
        undefined,
        customHeaders
    );

    if (errors) {
        console.error(`GRS API failed`, errors[0]?.message);
        throw new Error(errors[0]?.message);
    }

    const isSMBSalesLead =
        data?.growthUnifiedProfile_getUnifiedProfile?.userProfile
            ?.smbUserVisitedPricingPages;

    return isSMBSalesLead;
};
